import type { IncidentCategory, IncidentPriority, IncidentStatus } from '../../types/extranet-api.types';

/**
 * Libellés des énumérations d'incident du contrat v1.9.0.
 *
 * Les 14 catégories, les 2 statuts et les 3 priorités viennent du back : plus de
 * taxonomie front, plus de sous-catégories. Ajouter une valeur ici ne suffit
 * pas — c'est le back qui l'émet.
 */

export const CATEGORY_LABELS: Record<IncidentCategory, string> = {
  delay: 'Retard',
  driver_no_show: 'Chauffeur absent',
  driver_unreachable: 'Chauffeur injoignable',
  pickup_error: 'Erreur de prise en charge',
  trip_not_done: 'Course non réalisée',
  issue_during_trip: 'Incident pendant la course',
  driver_behavior: 'Comportement du chauffeur',
  safety_driving: 'Conduite dangereuse',
  vehicle: 'Véhicule',
  booking_error: 'Erreur de réservation',
  cancellation: 'Annulation',
  billing: 'Facturation',
  lost_item: 'Objet oublié',
  other: 'Autre',
};

/** Ordre d'affichage dans les filtres et le sélecteur de création. */
export const ALL_CATEGORIES: IncidentCategory[] = [
  'delay',
  'driver_no_show',
  'driver_unreachable',
  'pickup_error',
  'trip_not_done',
  'issue_during_trip',
  'driver_behavior',
  'safety_driving',
  'vehicle',
  'booking_error',
  'cancellation',
  'billing',
  'lost_item',
  'other',
];

/** Une catégorie inconnue du front s'affiche telle quelle plutôt que vide. */
export const categoryLabel = (category: string): string => CATEGORY_LABELS[category as IncidentCategory] ?? category;

export const STATUS_LABELS: Record<IncidentStatus, string> = {
  open: 'Ouvert',
  resolved: 'Résolu',
};

interface StatusColorTokens {
  bg: string;
  text: string;
  dot: string;
}

export const STATUS_COLORS: Record<IncidentStatus, StatusColorTokens> = {
  open: { bg: 'bg-amber-50', text: 'text-amber-800', dot: 'bg-amber-500' },
  resolved: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500' },
};

export const ALL_STATUSES: IncidentStatus[] = ['open', 'resolved'];

export const PRIORITY_LABELS: Record<IncidentPriority, string> = {
  high: 'Haute',
  medium: 'Moyenne',
  low: 'Basse',
};

export const PRIORITY_COLORS: Record<IncidentPriority, { dot: string; text: string }> = {
  high: { dot: 'bg-red-500', text: 'text-zinc-700' },
  medium: { dot: 'bg-amber-500', text: 'text-zinc-700' },
  low: { dot: 'bg-zinc-400', text: 'text-zinc-700' },
};

export const ALL_PRIORITIES: IncidentPriority[] = ['high', 'medium', 'low'];
